export default {
    helpButton: {
        color: "#7ac0f8",
        padding: "2px",
        textDecoration: "underline",
        marginLeft: "10px"
    },
    popper: {
        '&[x-placement*="bottom"] $arrow': {
            top: "-15px",
            right: "40px",
            marginTop: '-5px',
            "-ms-transform": "rotate(90deg)",
            "-webkit-transform": "rotate(90deg)",
            transform: "rotate(90deg)",
            filter: "drop-shadow(-1px 0 0 rgba(211,211,211,0.8))"
        },
        '&[x-placement*="right"] $arrow': {
            top: "35px !important",
            left: 0,
            marginLeft: '-5px',
            filter: "drop-shadow(-1px 0 0 rgba(211,211,211,0.8))"
        },
        '&[x-placement*="left"] $arrow': {
            top: "35px !important",
            right: 0,
            marginRight: '-5px',
            "-ms-transform": "rotate(180deg)",
            "-webkit-transform": "rotate(180deg)",
            transform: "rotate(180deg)",
            filter: "drop-shadow(-2px 0 0 rgba(200,200,200,0.5))"
        },
        '&[x-placement*="right"]': {
            margin: "98px 15px"
        },
        '&[x-placement*="left"]': {
            margin: "98px 20px"
        },
        '&[x-placement*="bottom"]': {
            margin: "10px 20px"
        }
    },
    arrow: {
        position: 'absolute'
    },
    popperContent: {
        padding: "15px 15px",
        width: "300px",
        boxShadow: "none",
        borderTop: "rgba(211,211,211,0.8) solid 1px",
        borderRight: "rgba(200,200,200,0.5) solid 2px",
        borderLeft: "rgba(211,211,211,0.8) solid 1px",
        borderBottom: "rgba(200,200,200,0.5) solid 2px",
    },
    row: {
        display: "flex",
    }
}